<template>
  <div></div>
</template>

<script>
export default {
  name: "BaseForm",
  data() {
    return {
      error: {
        messages: undefined,
        fieldErrors: [],
      },
      valid: false,
    };
  },
  methods: {
    getFieldErrorIndex(fieldName) {
      if (this.error.fieldErrors) {
        return this.error.fieldErrors.findIndex(
          (fieldError) => fieldError.field === fieldName
        );
      }
      return -1;
    },

    checkApiErrors(fieldName) {
      const fieldIndex = this.getFieldErrorIndex(fieldName);
      if (fieldIndex !== -1) {
        return this.error.fieldErrors[fieldIndex].message;
      }
    },

    resetApiErrors(fieldName) {
      const fieldIndex = this.getFieldErrorIndex(fieldName);
      if (fieldIndex !== -1) {
        this.error.fieldErrors.splice(fieldIndex, 1);
      }
    },

    populateErrors(error) {
      if (error.response && error.response.data) {
        if (error.response.data.messages) {
          this.$set(this.error, "messages", error.response.data.messages);
        }
        if (error.response.data.fieldErrors) {
          this.$set(this.error, "fieldErrors", error.response.data.fieldErrors);
        }
      }
    },
  },
};
</script>
